export default function UserSkill({ openModal, skills, skillSet, lang }: any) {
  const getSkillsName = (id: number) =>
    skillSet.find((i: any) => i.id == id)?.name || "-";

  return (
    <div className="bg-white p-4 rounded-xl border space-y-4">
      <div className="flex justify-between items-center">
        <h3 className="text-lg font-semibold">{lang === "id" ? "Keahlian" : "Skills"}<span className="text-red-500">*</span></h3>
        <button
          onClick={() => openModal("skill")}
          className="text-primary hover:underline"
        >
          ✎ Edit
        </button>
      </div>

      {/* chips */}
      <div className="flex flex-wrap gap-2">
        {skills?.length > 0 ? (
          skills.map((exp: any, idx: number) => (
            <span
              key={idx}
              className="px-4 py-1 rounded-full text-sm bg-blue-100 text-blue-700 border border-blue-300"
            >
              {getSkillsName(exp.skillName)}
            </span>
          ))
        ) : (
          <p className="text-gray-400 text-sm">No skills added</p>
        )}
      </div>
    </div>
  );
}
